import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import map from 'lodash/map';

const TabsContainer = styled.div`
  display: flex;
  min-height: 30px;
  margin: 0 0 16px;
`;

const Tab = styled.div`
  min-height: 30px;
  width: 193px;
  padding: 5px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.isActive ? '#4a90e2' : '#fafafb')};
  color: ${(props) => (props.isActive ? '#ffffff' : '#979ea7')};
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: 0.1px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  &:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  &:last-child {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  @media (max-width: 768px) {
    width: 150px;
  }
`;

const Tabs = (props) => {
  const { tabs, activeTab, onTabChange } = props;

  return (
    <TabsContainer>
      {map(tabs, (tab, index) => (
        <Tab
          key={`tab${index}`}
          isActive={tab.id === activeTab.id}
          onClick={() => onTabChange(tab)}
        >
          {tab.name}
        </Tab>
      ))}
    </TabsContainer>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array,
  activeTab: PropTypes.object,
  onTabChange: PropTypes.func,
};

Tabs.defaultProps = {
  tabs: [],
  activeTab: {},
  onTabChange: () => {},
};

export default Tabs;
